// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"7167d8fd","228":"3e113804","623":"e9f96f36","630":"298e9998","732":"0ebca8bd","922":"8e3e5962"}[chunkId] + ".chunk.js";
};